import { IObservable, Subject } from '~/rage/utils';
import { Apps } from '~/shared';
import { ITabletService } from './tabletServiceTypes';

export class TabletServiceStub implements ITabletService {
	private activeApp = new Subject<Apps | null>(null);

	constructor() {
		(window as any).setTabletActiveApp = (app: Apps | null) => {
			this.activeApp.next(app);
		};
	}

	public getActiveApp(): IObservable<Apps | null> {
		return this.activeApp;
	}
}
